import React from "react"
import { PartnerBilling } from "@flexday/common-react"

export const Report = ({ report }) => {
  return <PartnerBilling.Report report={report} />
}
